import React from 'react'
import PropTypes from 'prop-types'
import {
  MarkCompleteButton,
  MarkCompleteIconWrapper,
  ThemedMarkCompleteButtonIcon,
} from './component.styles'

const MARK_DONE_TEXT = 'Mark Done'
const DONE_TEXT = 'Done'

const MarkCompleteV25Component = ({
  isComplete,
  handleMarkComplete,
  useSecondaryMarkCompleteButton = false,
}) => {
  return (
    <MarkCompleteButton
      disabled={isComplete}
      isComplete={isComplete}
      onClick={handleMarkComplete}
      useSecondaryMarkCompleteButton={useSecondaryMarkCompleteButton}
    >
      {isComplete && (
        <MarkCompleteIconWrapper>
          <ThemedMarkCompleteButtonIcon
            useSecondaryMarkCompleteButton={useSecondaryMarkCompleteButton}
          />
        </MarkCompleteIconWrapper>
      )}
      {isComplete ? DONE_TEXT : MARK_DONE_TEXT}
    </MarkCompleteButton>
  )
}

MarkCompleteV25Component.propTypes = {
  handleMarkComplete: PropTypes.func.isRequired,
  isComplete: PropTypes.bool.isRequired,
  useSecondaryMarkCompleteButton: PropTypes.bool,
}

export default MarkCompleteV25Component
